import { useContextSelector } from 'use-context-selector';
import { MarkdownOpenExternalLinkCtx } from '../../ctx/OpenExternalLinkCtx';
import type { SupportIconProps } from '../Icon/SupportIconPropsNode';
import SupportIconPropsNode from '../Icon/SupportIconPropsNode';
import type { MdComponentIndexProps } from '../type';
import styles from './Card.module.less';
import React from 'react';

type MarkdownCardProps = {
  href: string;
  title: string;
  className: string;
  style: React.CSSProperties;
} & SupportIconProps &
  MdComponentIndexProps;

const MarkdownCard = function (props: React.PropsWithChildren<MarkdownCardProps>) {
  const openExternalLink = useContextSelector(
    MarkdownOpenExternalLinkCtx,
    (data) => data.openExternalLink,
  );
  const urlRef = React.useRef<HTMLAnchorElement>(null);

  return (
    <div
      className={`${styles.card} ${props.className}`}
      data-href={props.href || undefined}
      data-markdown-component="x-card"
      // target="_blank"
      style={props.style}
      onClick={(e) => {
        if (props.href) {
          openExternalLink?.(props.href, e.nativeEvent);
        }

        urlRef.current?.click();
      }}
      data-first={props['data-first']}
      data-last={props['data-last']}
      // href={props.href}
    >
      <a className='hidden' ref={urlRef} href={props.href} rel="noreferrer" />
      <div className={styles.cardContainer}>
        {props.icon ? (
          <div className={styles.cardIcon}>
            <SupportIconPropsNode {...props} />
          </div>
        ) : null}
        <div className={styles.cardTitle}>{props.title}</div>
        <span className={`${styles.cardContent} markdown-child-root`}>{props.children}</span>
      </div>
    </div>
  );
};
const attributes: (keyof MarkdownCardProps)[] = [
  'href',
  'title',
  'className',
  'style',
  'icon',
  'iconColor',
];
MarkdownCard.attributes = attributes;
MarkdownCard.displayName = 'MarkdownCard';

export { MarkdownCard };
